import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from '@zola/zola-ui';

const ChecklistFilterTag = ({ facetLabel, facetKey, toggleFilter }) => (
  <Tag type="filter" onClick={() => toggleFilter(facetKey)}>
    {facetLabel}
  </Tag>
);

ChecklistFilterTag.propTypes = {
  toggleFilter: PropTypes.func.isRequired,
  facetKey: PropTypes.string,
  facetLabel: PropTypes.string,
};

ChecklistFilterTag.defaultProps = {};

export default ChecklistFilterTag;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistActiveFilterTags/ChecklistFilterTag/ChecklistFilterTag.jsx